import createFeatureToggle from './createFeatureToggle';
import initialConfig from './initialConfig';

export default createFeatureToggle(initialConfig);
